<template>
    <div>
        <div class="itxst">
            <div class="col">
                <div class="title">{{$t("systemSetting.unBindDevice")}}</div>
                <draggable v-model="arr1" :group="groupA" animation="300" dragClass="dragClass" ghostClass="ghostClass"
                           chosenClass="chosenClass">
                    <transition-group :style="style">
                        <div class="item" v-for="item in arr1" :key="item.deviceNo">
                            {{ item.deviceName }}
                            <div class="container">{{item.containerName}}</div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
            <div class="col">
                <div class="title">{{$t("systemSetting.BindedDevice")}}</div>
                <draggable v-model="arr2" :group="groupB" animation="300" dragClass="dragClass" ghostClass="ghostClass"
                           chosenClass="chosenClass">
                    <transition-group :style="style">
                        <div class="item" v-for="item in arr2" :key="item.deviceNo">
                            {{ item.deviceName }}
                            <div class="container">{{item.containerName}}</div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <div class="footer">
            <el-button size="small" @click="close(false)">{{ $t('ems.strategy.cancel') }}</el-button>
            <el-button size="small" type="primary" @click="subminAdd" :loading="saveLoading">{{
                $t('ems.strategy.confirm') }}
            </el-button>
        </div>
    </div>

</template>

<script>
    import draggable from "vuedraggable";
    import { getEnvBindDevices, getEnvunBindDevices, doEnvBindDevices} from "@/api/spms";
    import i18n from "@/lang";

    export default {
        components: {draggable},
        props: ['id'],
        data() {
            return {
                drag: false,
                message: "",
                groupA: {
                    name: "itxst",
                    put: true, //可以拖入
                    pull: true,
                },
                groupB: {
                    name: "itxst",
                    pull: true, //B组拖拽时克隆到A组
                    put: true,
                },
                //定义要被拖拽对象的数组
                arr1: [


                ],
                arr2: [], //空数组
                arr3: [], //空数组
                //空数组之在的样式，设置了这个样式才能拖入
                style: "height:520px; display: block; overflow-y: auto;",

                saveLoading: false,
            };
        },
        mounted(){
            this.init();
        },
        methods: {
            //开始拖拽事件
            onStart() {
                this.drag = true;
                return true;
            },
            //拖拽结束事件
            onEnd() {
                this.drag = false;
            },

            close(flag){
                this.$emit('close', flag);
            },

            subminAdd(){
                if(this.arr2.length === 0) {
                    this.$message.warning(i18n.t("systemSetting.chooseTips"));
                    return false;
                }
                doEnvBindDevices({ "envId": this.id, "deviceNos": this.arr2.map(i => i.deviceNo)}).then(res => {
                    if(res && res.data && res.data.success){
                        this.$message.success(i18n.t("ems.SuccessfulOperation"));
                        this.close(true);
                    }else{
                        this.$message.success(i18n.t("ems.operationFailed"));
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.success(i18n.t("ems.operationFailed"));
                })
            },

            async init() {
                const res1 = await getEnvunBindDevices(this.id);
                const res2 = await getEnvBindDevices(this.id);
                if(res1 && res1.data && res1.data.data){
                    this.arr1 =res1.data.data;
                }
                if(res2 && res2.data && res2.data.data){
                    this.arr2 =res2.data.data;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/site";

    /*定义要拖拽元素的样式*/
    .ghostClass {
        background-color: #4b79b7 !important;
    }

    .chosenClass {
        background-color: #515151 !important;
        opacity: 1 !important;
    }

    .dragClass {
        background-color: #515151 !important;
        opacity: 1 !important;
        box-shadow: none !important;
        outline: none !important;
        background-image: none !important;
    }

    .itxst {
        margin: 10px;
        display: flex;
        justify-content: space-between;
    }

    .title {
        color: $font_bright_blue_title;

        padding: 6px 12px;
    }

    .col {
        width: 48%;
        padding: 10px;
        border: solid 1px #eee;
        border-radius: 5px;
    }

    .col + .col {
        margin-left: 10px;
    }

    .item {
        background-color: var(--nav_inner);
        width: 135px;
        height: 60px;
        box-sizing: border-box;
        padding: 5px;
        margin: 5px;
        float: left;
        user-select: none;
        color: $font_bright_blue_title;
        position: relative;
        .container{
            position: absolute;
            bottom: 5px;
            right: 5px;
            text-align: right;
            color: rgb(192, 192, 192);
        }
    }

    .item:hover {
        background-color: rgb(87, 87, 87);
        cursor: move;
    }

    .item + .item {
        border-top: none;
        margin-top: 6px;
    }

    .footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
    }
</style>